import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/** A keycap chip — the same look as the ⌘K hint in the header search box. */
export function Kbd({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <kbd
      className={cn(
        "text-muted-foreground bg-muted pointer-events-none inline-flex h-4 min-w-4 items-center justify-center rounded border px-1 font-mono text-[10px] leading-none",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
